/**
 * @generated SignedSource<<5241f8e7b075c8228f2573df36132b2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type CertificationKind = "CertificationUpgrade" | "CourseContentOnly" | "WithCertification";
export type LicenseCreationInfoKind = "Admin" | "Converter" | "Order" | "Registration";
export type LicenseUsageKind = "Free" | "UsedForTree";
import { FragmentRefs } from "relay-runtime";
export type licensesTable_LicenseFragment$data = {
  readonly certificationData: {
    readonly __typename: string;
    readonly kind: CertificationKind;
  } | null;
  readonly creationInfo: {
    readonly createdAt: string;
    readonly creatorId?: string;
    readonly kind: LicenseCreationInfoKind;
    readonly licenseDefinition: {
      readonly data: {
        readonly name: string;
      };
    } | null;
    readonly orderId?: string;
    readonly userId?: string;
  };
  readonly id: string;
  readonly timeBasedInfo: {
    readonly endDateTime: string;
    readonly startDateTime: string;
  } | null;
  readonly usage: {
    readonly at?: string;
    readonly forUser?: {
      readonly email: string;
    } | null;
    readonly kind: LicenseUsageKind;
  };
  readonly " $fragmentType": "licensesTable_LicenseFragment";
};
export type licensesTable_LicenseFragment$key = {
  readonly " $data"?: licensesTable_LicenseFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"licensesTable_LicenseFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "licensesTable_LicenseFragment"
};

(node as any).hash = "0e66b2dd8174b1c2255e409285c37c0f";

export default node;
